import { useEffect, useState } from "react"
import SelectTabs from "../../../../molecules/SelectTabs"
import { fnCanAtLeast } from "../../../../../utils/permissions"
import { useNavigate } from "react-router-dom"
import intl from "react-intl-universal"

export default function PageTabs({currentTab}) {
  const navigate = useNavigate()

  const isAccessSigma = fnCanAtLeast("access-sigma", "internal-quality-control")

  const tabCIQ = {
    value: 1,
    label: intl.get("ciq.page_tabs.reviews"),
    name: "avaliacoes",
  }

  const tabSigma = {
    value: 2,
    label: intl.get("ciq.page_tabs.sigma"),
    name: "sigma",
  }

  const tabSistem = isAccessSigma ? [tabCIQ, tabSigma] : [tabCIQ]

  const [selectedTab, setSelectedTab] = useState(tabCIQ)
  
  useEffect(() => {
    if (!currentTab) return;

    setSelectedTab(tabSistem.find(tab => tab.value === currentTab))
  }, [currentTab])

  const pagesMap = {
    1: "/ciq",
    2: "/ciq/sigma",
  }
  const fnTabSelected = (tab) => {
    setSelectedTab(tab)
    const route = pagesMap[tab.value]
    navigate(route)
  }

  return (
    <SelectTabs
      tabs={tabSistem}
      disableCloseTab={true}
      oSelectTab={selectedTab}
      onSelectTab={fnTabSelected}
    />
  )
}
